/**Модель результата создания комментария */
export class CreateCommentResultModel {
  /**ID комментария */
  CommentId!: number;
  /**ID родительского комментария */
  ParentCommentId?: number;
  /**Текст комментария */
  Text!: string;
  /**Дата создания комментария */
  DateCreate!: Date;

  constructor(obj?: Partial<CreateCommentResultModel>) {
    Object.assign(this, obj);
  }
}
